import React, { Component } from "react";
import {
  Box,
  Button,
  IconButton,
  Select,
  MenuItem,
  Input,
  Checkbox,
  FormControlLabel,
  Slider, // Import Slider for opacity
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import FormatBoldIcon from "@material-ui/icons/FormatBold";
import FormatItalicIcon from "@material-ui/icons/FormatItalic";
import FormatUnderlinedIcon from "@material-ui/icons/FormatUnderlined";
import FormatAlignLeftIcon from "@material-ui/icons/FormatAlignLeft";
import FormatAlignCenterIcon from "@material-ui/icons/FormatAlignCenter";
import FormatAlignRightIcon from "@material-ui/icons/FormatAlignRight";
import VerticalAlignTopIcon from "@material-ui/icons/VerticalAlignTop";
import VerticalAlignCenterIcon from "@material-ui/icons/VerticalAlignCenter";
import VerticalAlignBottomIcon from "@material-ui/icons/VerticalAlignBottom";
import { BlockPicker } from "react-color";
import { useTranslation } from "react-i18next";

const styles = (theme) => ({
  button: {
    fontSize: 12,
    textTransform: 'none',
    padding: '4px 8px',
    minWidth: '60px',
  },
  iconButton: {
    margin: theme.spacing(0.5),
    color: "#444",
    border: "1px solid #ccc",
    borderRadius: "4px",
    padding: "3px",
    width: "24px",
    height: "24px",
    "&.active": {
      backgroundColor: "#e0e0e0",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "16px",
    },
  },
  pickerContainer: {
    position: "absolute",
    zIndex: 20010,
    backgroundColor: "#fff",
    padding: "8px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: "4px",
    border: "1px solid #ddd",
  },
  colorBox: {
    width: "20px",
    height: "20px",
    display: "inline-block",
    border: "1px solid #ddd",
    borderRadius: "3px",
    margin: "2px",
    cursor: "pointer",
  },
  container: {
    position: "fixed",
    top: "250px",
    left: "50px",
    zIndex: 9999,
    width: "400px",
    backgroundColor: "#fff",
    padding: "12px",
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
    borderRadius: "6px",
    border: "1px solid #ddd",
    overflow: "visible",
  },
  container1: {
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    gridTemplateRows: "auto auto",
    gap: "8px",
    position: "relative",
    marginBottom: "12px",
  },
  section: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    position: "relative",
    "& p": {
      margin: "2px 0",
      fontSize: "12px",
      color: "#333",
    },
    "& .MuiInput-root": {
      fontSize: "12px",
    },
    "& .MuiSelect-root": {
      fontSize: "12px",
      padding: "4px",
    },
    "& .MuiInput-input": {
      padding: "4px",
      width: "40px",
    },
  },
  section2: {
    display: "flex",
    alignItems: "center",
    gap: "1px",
  },
  colorSection: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
    "& p": {
      margin: "2px 0",
      fontSize: "12px",
      color: "#333",
    },
  },
  backgroundSection: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    "& p": {
      margin: "2px 0",
      fontSize: "12px",
      color: "#333",
    },
  },
  backgroundColorRow: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "8px",
  },
  colorControls: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  opacityControl: {
    display: "flex",
    flexDirection: "column",
    gap: "2px",
  },
  opacitySlider: {
    display: "block !important",
    height: "auto !important",
    width: "80px",
    padding: "4px 0",
    "& .MuiSlider-root": {
      padding: "6px 0",
    },
    "& .MuiSlider-thumb": {
      width: 16,
      height: 16,
    },
    "& .MuiSlider-rail, & .MuiSlider-track": {
      height: 4,
    },
  },
  closeButton: {
    position: "absolute",
    top: "6px",
    right: "6px",
    backgroundColor: "#f5f5f5",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "12px",
    border: "1px solid #ddd",
    zIndex: 30000,
    "&:hover": {
      backgroundColor: "#e0e0e0",
    },
  },
  warningText: {
    fontSize: "10px",
    color: "#666",
    fontStyle: "italic",
    margin: "2px 0",
    lineHeight: "1.2",
  },
  checkboxLabel: {
    "& .MuiFormControlLabel-label": {
      fontSize: "12px",
    },
    "& .MuiCheckbox-root": {
      padding: "2px",
    },
    "& .MuiSvgIcon-root": {
      fontSize: "18px",
    },
  },
  fontSelect: {
    width: '100%',
    '& .MuiSelect-select': {
      width: '100%',
      paddingRight: '24px', // Space for the arrow
      fontSize: '12px',
    },
    '& .MuiSelect-icon': {
      right: '0',
    },
    '& .MuiMenuItem-root': {
      fontSize: '12px',
      minHeight: '32px',
    },
  },
  fontSizeInput: {
    width: '100%',
    '& .MuiInput-input': {
      width: '100%',
      padding: '8px',
      border: '1px solid rgba(0, 0, 0, 0.23)',
      borderRadius: '4px',
      fontSize: '12px',
      '&:hover': {
        borderColor: 'rgba(0, 0, 0, 0.87)',
      },
      '&:focus': {
        borderColor: theme.palette.primary.main,
        borderWidth: '2px',
        padding: '7px',
      },
    },
  },
});

class TextStyle extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fontWeight: "normal", 
      fontStyle: "normal", 
      textDecoration: "none", 
      textAlign: "center",
      verticalAlign: "bottom", 
      fontSize: "16px", 
      fontFamily: "Arial", 
      textColor: "#fff",
      backgroundColor: "#000",
      backgroundOpacity: 1, 
      applyAll: false, // State for "Apply to All"
      customColors: [
        "#000000", // Black
        "#FFD700", // gold
        "#FF0000", // Red
        "#00FF00", // Green
        "#0000FF", // Blue
        "#D9E3F0", // Light Blue
        "#F47373", // Light Red
        "#697689", // Gray
        "#37D67A", // Light Green
        "#2CCCE4", // Light Blue
        "#555555", // Dark Gray
        "#dce775", // Light Yellow
        "#ff8a65", // Light Orange
        "#ba68c8", // Light Purple
        "#FFC107", // Amber
      ],
      displayTextColorPicker: false,
      displayBackgroundColorPicker: false,
    };
    this.textColorPickerRef = React.createRef();
    this.backgroundColorPickerRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event) => {
    if (this.textColorPickerRef.current && 
        !this.textColorPickerRef.current.contains(event.target) &&
        !event.target.closest('.colorBox')) {
      this.setState({ displayTextColorPicker: false });
    }
    if (this.backgroundColorPickerRef.current && 
        !this.backgroundColorPickerRef.current.contains(event.target) &&
        !event.target.closest('.colorBox')) {
      this.setState({ displayBackgroundColorPicker: false });
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.selectedStyles !== this.props.selectedStyles) {
      // Only update state if the individual styles have changed
      this.setState((prevState) => {
        let newState = {};
        if (prevProps.selectedStyles.fontWeight !== this.props.selectedStyles.fontWeight) {
          newState.fontWeight = this.props.selectedStyles.fontWeight;
        }
        if (prevProps.selectedStyles.fontStyle !== this.props.selectedStyles.fontStyle) {
          newState.fontStyle = this.props.selectedStyles.fontStyle;
        }
        if (prevProps.selectedStyles.textDecoration !== this.props.selectedStyles.textDecoration) {
          newState.textDecoration = this.props.selectedStyles.textDecoration;
        }
        if (prevProps.selectedStyles.textAlign !== this.props.selectedStyles.textAlign) {
          newState.textAlign = this.props.selectedStyles.textAlign;
        }
        if (prevProps.selectedStyles.verticalAlign !== this.props.selectedStyles.verticalAlign) {
          newState.verticalAlign = this.props.selectedStyles.verticalAlign;
        }
        if (prevProps.selectedStyles.fontSize !== this.props.selectedStyles.fontSize) {
          newState.fontSize = this.props.selectedStyles.fontSize;
        }
        if (prevProps.selectedStyles.fontFamily !== this.props.selectedStyles.fontFamily) {
          // Ensure font family is properly formatted (remove quotes and trim)
          const fontFamily = this.props.selectedStyles.fontFamily;
          newState.fontFamily = fontFamily ? fontFamily.replace(/['"]+/g, '').trim() : "Arial";
        }
        if (prevProps.selectedStyles.textColor !== this.props.selectedStyles.textColor) {
          newState.textColor = this.props.selectedStyles.textColor;
        }
        if (prevProps.selectedStyles.backgroundColor !== this.props.selectedStyles.backgroundColor) {
          newState.backgroundColor = this.props.selectedStyles.backgroundColor;
        }
        if (prevProps.selectedStyles.backgroundOpacity !== this.props.selectedStyles.backgroundOpacity) {
          newState.backgroundOpacity = this.props.selectedStyles.backgroundOpacity;
        }
  
        return newState;
      });
    }
  }
  toggleStyle = (style) => {
    this.setState((prevState) => {
      let newState = {};
      if (style === "bold") {
        newState.fontWeight =
          prevState.fontWeight === "bold" ? "normal" : "bold";
      } else if (style === "italic") {
        newState.fontStyle =
          prevState.fontStyle === "italic" ? "normal" : "italic";
      } else if (style === "underline") {
        newState.textDecoration =
          prevState.textDecoration === "underline" ? "none" : "underline";
      }
      return newState;
    });
  };

  // Apply styles to the selected text or all
  applyStyle = () => {
    const { applyAll, ...styles } = this.state;
    // Ensure font size has 'px' unit
    if (styles.fontSize && !styles.fontSize.includes('px')) {
      styles.fontSize = `${styles.fontSize}px`;
    }
    // Ensure font family is properly formatted
    if (styles.fontFamily) {
      styles.fontFamily = styles.fontFamily.replace(/['"]+/g, ''); // Remove any quotes
    }
    this.props.onApplyStyle({ ...styles, applyAll });
    this.props.onClose(); 
  }
  // Clear all styles by setting styles array to empty
  clearStyles = () => {
    const { applyAll } = this.state;
    
    // Format the background style properly with black background
    const formattedStyles = {
        textColor: undefined,
        background: {
            color: "#000000",
            opacity: 1
        },
        applyAll: applyAll
    };
    
    this.props.onApplyStyle(formattedStyles);
    this.props.onClose();
  };

  handleOpacityChange = (e, newValue) => {
    this.setState({ backgroundOpacity: newValue });
  };
  handleTextColorChange = (color) => {
    this.setState({ textColor: color.hex });
    this.setState({ displayTextColorPicker: false });
  };
  handleTextColorPickerToggle = (event) => {
    if (event) {
      this.setState({ pickerPosition: { x: event.clientX, y: event.clientY } });
    }
    this.setState({
      displayTextColorPicker: !this.state.displayTextColorPicker,
    });
  };

  handleBackgroundColorChange = (color) => {
    this.setState({ backgroundColor: color.hex });
    this.setState({ displayBackgroundColorPicker: false });
  };

  handleBackgroundColorPickerToggle = (event) => {
    if (event) {
      this.setState({ pickerPosition: { x: event.clientX, y: event.clientY } });
    }
    this.setState({
      displayBackgroundColorPicker: !this.state.displayBackgroundColorPicker,
    });
  };

  render() {
    const { classes, open, t } = this.props;
    const {
      fontWeight,
      fontStyle,
      textDecoration,
      textAlign,
      verticalAlign,
      fontSize,
      fontFamily,
      textColor,
      backgroundColor,
      backgroundOpacity,
      applyAll,
      customColors,
      displayTextColorPicker,
      displayBackgroundColorPicker,
    } = this.state;
    if (!open) return null;

    return (
      <Box ref={this.props.boxRef} className={classes.container}>
        {/* Close Button in Top Right */}
        <IconButton
          className={classes.closeButton}
          onClick={this.props.onClose}
        >
          ✖
        </IconButton>
        <Box className={classes.container1}>
          {/* Font Family */}
          <Box className={classes.section} style={{ position: 'relative', zIndex: 20000 }}>
            <Select
              className={classes.fontSelect}
              key={this.state.fontFamily}
              fullWidth
              value={fontFamily}
              onChange={(e) => {
                this.setState({ fontFamily: e.target.value });
              }}
              MenuProps={{
                getContentAnchorEl: null,
                anchorOrigin: {
                  vertical: 'bottom',
                  horizontal: 'left',
                },
                transformOrigin: {
                  vertical: 'top',
                  horizontal: 'left',
                },
                style: {
                  zIndex: 25000
                },
                PopoverProps: {
                  style: {
                    zIndex: 25000
                  }
                }
              }}
              variant="outlined"
              displayEmpty
            >
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Arial">Arial</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Courier New">Courier New</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Georgia">Georgia</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Helvetica">Helvetica</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Open Sans">Open Sans</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Roboto">Roboto</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Tahoma">Tahoma</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Times New Roman">Times New Roman</MenuItem>
              <MenuItem style={{ fontSize: '12px', minHeight: '32px' }} value="Verdana">Verdana</MenuItem>
            </Select>
          </Box>

          {/* Font Size */}
          <Box className={classes.section} style={{ zIndex: 10001}}>
            <Input
              className={classes.fontSizeInput}
              type="number"
              value={fontSize.replace("px", "")}
              onChange={(e) =>
                this.setState({ fontSize: `${e.target.value}px` })
              }
              disableUnderline
            />
          </Box>

          {/* Text Color */}
          <Box className={classes.colorSection} style={{ zIndex: 10012 }}>
            <p>{t("EDITOR.textColor")}</p>
            <div
              className={classes.colorBox}
              style={{ background: textColor }}
              onClick={this.handleTextColorPickerToggle}
            />
            {displayTextColorPicker && (
              <div
                ref={this.textColorPickerRef}
                className={classes.pickerContainer}
                style={{
                  left: `${this.state.pickerPosition.x} -20 px`,
                  top: "50px",
                  zIndex: 10013
                }}
              >
                <BlockPicker
                  color={textColor}
                  colors={customColors}
                  triangle={"hide"}
                  onChangeComplete={this.handleTextColorChange}
                  onChange={this.handleTextColorChange}
                />
              </div>
            )}
          </Box>

          <Box className={classes.section}>
            <Box className={classes.section2}>
              <IconButton
                className={`${classes.iconButton} ${
                  fontWeight === "bold" ? "active" : ""
                }`}
                onClick={() => this.toggleStyle("bold")}
              >
                <FormatBoldIcon />
              </IconButton>
              <IconButton
                className={`${classes.iconButton} ${
                  fontStyle === "italic" ? "active" : ""
                }`}
                onClick={() => this.toggleStyle("italic")}
              >
                <FormatItalicIcon />
              </IconButton>
              <IconButton
                className={`${classes.iconButton} ${
                  textDecoration === "underline" ? "active" : ""
                }`}
                onClick={() => this.toggleStyle("underline")}
              >
                <FormatUnderlinedIcon />
              </IconButton>
            </Box>
          </Box>

          {/* Text Alignment */}
          <Box className={classes.section}>
            <Box className={classes.section2}>
              <IconButton
                className={`${classes.iconButton} ${
                  textAlign === "left" ? "active" : ""
                }`}
                onClick={() => this.setState({ textAlign: "left" })}
              >
                <FormatAlignLeftIcon />
              </IconButton>
              <IconButton
                className={`${classes.iconButton} ${
                  textAlign === "center" ? "active" : ""
                }`}
                onClick={() => this.setState({ textAlign: "center" })}
              >
                <FormatAlignCenterIcon />
              </IconButton>
              <IconButton
                className={`${classes.iconButton} ${
                  textAlign === "right" ? "active" : ""
                }`}
                onClick={() => this.setState({ textAlign: "right" })}
              >
                <FormatAlignRightIcon />
              </IconButton>
            </Box>
          </Box>

          {/* Vertical Alignment */}
          <Box className={classes.section}>
            <Box className={classes.section2}>
              <IconButton
                className={`${classes.iconButton} ${
                  verticalAlign === "top" ? "active" : ""
                }`}
                onClick={() => this.setState({ verticalAlign: "top" })}
              >
                <VerticalAlignTopIcon />
              </IconButton>
              <IconButton
                className={`${classes.iconButton} ${
                  verticalAlign === "middle" ? "active" : ""
                }`}
                onClick={() => this.setState({ verticalAlign: "middle" })}
              >
                <VerticalAlignCenterIcon />
              </IconButton>
              <IconButton
                className={`${classes.iconButton} ${
                  verticalAlign === "bottom" ? "active" : ""
                }`}
                onClick={() => this.setState({ verticalAlign: "bottom" })}
              >
                <VerticalAlignBottomIcon />
              </IconButton>
            </Box>
          </Box>
        </Box>

        <Box className={classes.backgroundSection} style={{ zIndex: 10011 }}>
          <Box className={classes.backgroundColorRow}>
            <p>{t("EDITOR.backgroundColor")}</p>
            <div
              className={classes.colorBox}
              style={{ background: backgroundColor }}
              onClick={this.handleBackgroundColorPickerToggle}
            />
            {displayBackgroundColorPicker && (
              <div
                ref={this.backgroundColorPickerRef}
                className={classes.pickerContainer}
                style={{
                  left: `${this.state.pickerPosition.x} -20 px`,
                  top: "50px",
                  zIndex: 10012
                }}
              >
                <BlockPicker
                  color={backgroundColor}
                  colors={customColors}
                  triangle={"hide"}
                  onChangeComplete={this.handleBackgroundColorChange}
                  onChange={this.handleBackgroundColorChange}
                />
              </div>
            )}
          </Box>
          <Box className={classes.opacityControl}>
            <p>{t("EDITOR.opacity")}</p>
            <Box className={classes.opacitySlider}>
              <Slider
                value={backgroundOpacity}
                onChange={this.handleOpacityChange}
                min={0}
                max={1}
                step={0.01}
                valueLabelDisplay="auto"
                valueLabelFormat={(value) => value.toFixed(2)}
              />
            </Box>
          </Box>
          <p className={classes.warningText}>
            {t("EDITOR.backgroundAlignmentWarning")}
          </p>
        </Box>

        <Box p={0.5} display="flex" width="100%" alignItems="center">
          <FormControlLabel
            className={classes.checkboxLabel}
            control={
              <Checkbox
                checked={applyAll}
                onChange={(e) => this.setState({ applyAll: e.target.checked })}
                color="primary"
                size="small"
              />
            }
            label={t("EDITOR.applyToAllText")}
          />
        </Box>
        <Box p={0.5} display="flex" width="100%" alignItems="center" justifyContent="space-between">
          <Button
            className={classes.button}
            color="secondary"
            variant="contained"
            onClick={this.clearStyles}
            style={{ marginRight: '6px', flex: 1 }}
          >
            {t("EDITOR.clear")}
          </Button>
          <Button
            className={classes.button}
            color="primary"
            variant="contained"
            onClick={this.applyStyle}
            style={{ flex: 1 }}
          >
            {t("EDITOR.apply")}
          </Button>
        </Box>
      </Box>
    );
  }
}

// Create a wrapper component to use the useTranslation hook
const TextStyleWithTranslation = (props) => {
  const { t } = useTranslation();
  return <TextStyle {...props} t={t} />;
};

export default withStyles(styles)(TextStyleWithTranslation);

